import { FaExchangeAlt, FaPlus, FaPencilAlt, FaBell } from 'react-icons/fa';
import { IconType } from 'react-icons';
import { MarkerAction } from '../types/marker';

export const getActionIcon = (type: MarkerAction['type'], hasReminder?: boolean): IconType => {
  // Si l'action a une notification, retourner l'icône de cloche, peu importe le type d'action
  if (hasReminder) {
    return FaBell;
  }

  // Si le type n'est pas défini, utiliser l'icône de crayon par défaut
  if (!type) {
    return FaPencilAlt;
  }

  switch (type) {
    case 'category_change':
      return FaExchangeAlt;
    case 'create':
      return FaPlus;
    case 'update':
      return FaPencilAlt;
    default:
      // Pour tous les autres types d'actions, utiliser l'icône de crayon
      return FaPencilAlt;
  }
};

export const getActionDescription = (action: MarkerAction): string => {
  switch (action.type) {
    case 'category_change':
      // Extraire uniquement les noms des catégories de la description
      const match = action.description.match(/: (.*) → (.*)/);
      if (match) {
        return `${match[1]} → ${match[2]}`;
      }
      return action.description;
    case 'create':
      return 'Création du marqueur';
    case 'update':
    default:
      return action.description;
  }
};

